var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7722 12.564C13.735 12.564 12.8101 13.0573 12.2185 13.8198L7.26454 11.0577C7.38062 10.7251 7.44427 10.3663 7.44427 9.99626C7.44427 9.62251 7.38062 9.26744 7.26079 8.93106L12.211 6.17276C12.7989 6.93895 13.7275 7.43605 14.7685 7.43605C16.5434 7.43605 17.9925 5.99336 17.9925 4.21802C17.9925 2.44269 16.5471 1 14.7685 1C12.9899 1 11.5445 2.44269 11.5445 4.21802C11.5445 4.59178 11.6082 4.95058 11.728 5.28322L6.7815 8.04153C6.19361 7.2716 5.26498 6.77824 4.22401 6.77824C2.44912 6.77824 1 8.22093 1 9.99626C1 11.7716 2.44912 13.2143 4.22775 13.2143C5.26872 13.2143 6.19736 12.7172 6.78899 11.9473L11.7392 14.7093C11.6194 15.0457 11.552 15.4082 11.552 15.782C11.552 17.5536 12.9974 19 14.776 19C16.5546 19 18 17.5573 18 15.782C18 14.0066 16.5509 12.564 14.7722 12.564Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d0b5623b.svg";
export { ForwardRef as ReactComponent };